<template>
  <div>
    <!--    <Divider orientation="left">单位基本信息</Divider>-->
    <Form ref="passwordResetForm" :model="form" :rules="rules" :label-width="180">
      <Row :gutter="16">
        <!--        <Col span="24">-->
        <!--          <FormItem label="业务流水号" prop="id">-->
        <!--            <Input v-model="form.id" disabled></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <Col span="24">
        <FormItem label="重置密码" prop="resetPasswordType">
          <RadioGroup v-model="form.resetPasswordType">
            <Radio v-for="select in uniPersonalList" :label="select.value" :key="select.value">{{ select.text }}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <template v-if="form.resetPasswordType == 1">

          <Col span="12">
          <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <div>
                  <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="(event, file, fileList) => updateProgress(event, file, fileList, 'applicantIDCardFrontGuidProgress')"
                    :show-upload-list="false" :accept="accept" :format="format" :data="{ readIdInfo: true }" :on-success="(response, file, fileList) => {
                        $refs['applicantIDCardFrontGuidProgress'].updateShow(false)
                        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                          response,
                          file,
                          fileList,
                          'applicantIDCardFrontGuid', false, 'idCard', [{ name: 'applicantName' }, { idCard: 'applicantIDCardNo' }]
                        )
                      }
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="applicantIDCardFrontGuidProgressUpload">
                        <Icon @click.stop="() => { return false }" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid', false, 'idCard', [{ name: 'applicantName' }, { idCard: 'applicantIDCardNo' }])">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                    </div>
                  </Upload>

                </div>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.applicantIDCardFrontGuid">
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL +
                      '/file/cover/' +
                      form.applicantIDCardFrontGuid
                      " />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="
                        handleRemove(
                          0,
                          form.applicantIDCardFrontGuid,
                          'applicantIDCardFrontGuid'
                        )
                        " type="ios-trash-outline" />
                    </i>
                  </span>
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{ readIdbackAfterUploaded: true }" :on-progress="(event, file, fileList) => updateProgress(event, file, fileList, 'applicantIDCardBackGuidProgress')"
                  class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="(response, file, fileList) => {
                      $refs['applicantIDCardBackGuidProgress'].updateShow(false)
                      $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid', false, 'idcard_back'
                      )
                    }
                    " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantIDCardBackGuidProgressUpload">
                      <Icon @click.stop="() => { return false }" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid', false, 'idcard_back')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.applicantIDCardBackGuid">
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="
                        handleRemove(
                          0,
                          form.applicantIDCardBackGuid,
                          'applicantIDCardBackGuid'
                        )
                        " type="ios-trash-outline" />
                    </i>
                  </span>
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>

          <Col span="12">
          <FormItem label="申请人姓名" prop="applicantName">
            <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="申请人身份证号" prop="applicantIDCardNo">
            <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="申请人联系方式" prop="applicantPhone">
            <Input v-model="form.applicantPhone" placeholder="请输入"></Input>
          </FormItem>
          </Col>
        </template>
        <Col span="12">
        <FormItem class="noticeTop" label="其他材料" prop="otherFileGuidList">
          <Upload ref="otherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.otherFileGuidListPreview" style="flex:1;" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList) => handleRemove(file, fileList, 'otherFileGuidList', true)"
            :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'otherFileGuidList', true)" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('otherFileGuidList', true)">手机拍照上传</Button>
          </Upload>
        </FormItem>
        <FormItem class="notice">
          <!-- <div>
            <a class="_link" :href="$baseURL + '/templates/密码重置申请表.doc'">下载重置密码申请表模板</a>
          </div> -->
          <div class="_linkdel" v-for="file in form.otherFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{ file.name ? file.name : file.fileName }}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'otherFileGuidList', true)" />
            </div>
          </div>
        </FormItem>
        </Col>

      </Row>
      <div class="bom_btn">
        <div>
          <Button @click="next(null, 0)">上一步</Button>
          <Button v-if="form.resetPasswordType == $store.state.passwordSourceTypes['个人']" type="primary" @click="next('passwordResetForm', 1)">下一步</Button>
          <Button v-if="form.resetPasswordType == $store.state.passwordSourceTypes['单位']" type="primary" @click="next('passwordResetForm', 1)">在线签章《重置密码申请表》</Button>

          <!-- <span v-else href="#">在线签字《重置密码申请表》</span> -->
        </div>
      </div>
    </Form>

    <!--扫码  -->
    <Modal title="请申请人使用微信扫码签名" v-model="QRshow" :closable="false" :mask-closable="false">
      <template #header>
        <p>
          <img src="../../../../../assets/images/weixin.png" class="QRtitle">
          <span v-if="form.resetPasswordType == 1">请申请人使用微信扫码签名</span>
          <span v-if="form.resetPasswordType == 5">请单位使用微信扫码签章</span>
        </p>
      </template>
      <div style="position:relative;">
        <div class="QRcode">
          <img :src="'data:image/png;base64,' + QRcode" alt="">
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>

      <template #footer>
        <Button @click="colseQR()" style="margin-right: 5px">关闭</Button>
      </template>
    </Modal>
    <!-- PDF  -->
    <Modal title="PDF预览" v-model="PDFshow" fullscreen :closable="false" :mask-closable="false">

      <div style="position:relative;">
        <div class="PDFcode">
          <embed style="width: 70vw; height: 85vh;" type="application/pdf" :src="$baseURL + '/file/preview/' + pdfCode + '?preview=true'">
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>

      <template #footer>
        <Button @click="PDFClose()" size="large" style="margin-right: 5px">关闭</Button>

        <Button @click="submitPassword()" size="large" type="primary" style="margin-right: 5px">提交</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, uniPersonalList: { type: Array } },
  data() {
    return {
      current: {},
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      QRshow: false,
      loading: false,
      PDFshow: false,
      QRcode: '',
      timer: null,
      pdfCode: null,
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      key: 0,
      rules: {
        resetPasswordType: [{ required: true, message: '请选择', type: 'number' }],
        applicantIDCardNo: [{ required: true, message: '请输入' }],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantName: [{ required: true, message: '请输入' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      timeout: null,
      // uniPersonalList: [],
    }
  },
  mounted() {
    // this.getInit(null, this.form.personnelId)
    this.form.guid = this.$route.query.guid
    if (this.$route.query.current == 200) {
      this.checxSgin()
    }
  },

  methods: {
    next(name, val) {
      let _this = this
      if (name) {
        this.$refs[name].validate(async (valid) => {
          if (!valid) {
            this.$Message.error('请将信息填写完整')
            return
          }
          // this.$emit('next', this.form.applicationType)
          //下一步
          //有提交路径才执行
          this.submitStore()
          //this.checkUserOpen()
        })
        return
      }
      this.$emit('next', val)
    },
    //暂存
    async submitStore() {
      let _this = this
      this.loading = true
      let params = {
        guid: null,
        enterpriseCode: null,
        enterpriseId: null,
        enterpriseName: null,
        personnelIDCardNo: null,
        personnelId: null,
        applicationType: null,
        personnelName: null,
        personnelPhone: null,
        resetPasswordType: null,
        applicantIDCardNo: null,
        applicantPhone: null,
        applicantName: null,
        applicantIDCardFrontGuid: null,
        applicantIDCardBackGuid: null,
        otherFileGuids: null,
        otherFileGuidList: [],
        otherFileGuidListPreview: [],
      }
      for (let key in params) {
        if (key in this.form) {
          params[key] = this.form[key]
        }
      }

      try {
        const { data } = await this.$Ajax.post(
          `/api/services/app/OtherApplicationApi/SaveResetPasswordApplicationInfo`,
          params
        )

        this.form.guid = data.result
        this.loading = false

        if (this.form.resetPasswordType == _this.$store.state.passwordSourceTypes['单位']) {
          location.href =
            this.$baseURL + '/CA/RedirectToCASignByResetPassword?guid=' + this.form.guid

          return
        }
        //个人打开手机扫码签名
        _this.checkUserOpen(data.result)
      } catch (error) {
        this.loading = false
        this.$Message.error({
          content: '出错了',
          background: true,
          duration: 6,
        })
      }
    },
    //关闭核验经办人弹窗
    colseQR() {
      this.QRshow = false
      clearTimeout(this.timer)
      this.timer = null
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },

    async checxSgin(isSing) {
      // 检查是否签成功

      this.PDFshow = true

      this.loading = true
      let _this = this
      // 定义轮询函数

      const checkSignStatus = async () => {
        try {
          // 获取签章结果

          const { data } = await _this.$Ajax.post(
            '/api/services/app/OtherApplicationApi/CASignCallbackCheck?guid=' + _this.form.guid
          )

          if (data.result.success) {
            // 签章成功，停止轮询
            _this.pdfCode = data.result.resetPasswordPdfGuid
            _this.loading = false

            clearInterval(pollingInterval)

            clearTimeout(_this.timeout)
          } else {
            // 签章失败，继续轮询
          }
        } catch (error) {
          _this.$Message.error({
            content: '在线签章失败',

            background: true,

            duration: 6,
          })
        }
        // finally {
        //   // 无论成功还是失败，都设置PDFshow和loading为false，以便在下次轮询时重新显示和加载

        //   _this.PDFshow = false

        //   _this.loading = false
        // }
      }

      // 设置初始轮询间隔

      const pollingInterval = setInterval(checkSignStatus, 5000)

      // 设置超时计时器

      this.timeout = setTimeout(() => {
        clearInterval(pollingInterval)

        this.$Message.error({
          content: '在线签章超时，请稍后重试',

          background: true,

          duration: 6,
        })
      }, 300000)
    }, // 5分钟

    // 打开PDF预览弹窗
    async PDFOpen(guid) {
      this.PDFshow = true
      this.loading = true
      let { data } = await this.$Ajax.post(
        '/api/services/app/OtherApplicationApi/GenerateResetPasswordPdf?guid=' + this.form.guid
      )
      this.pdfCode = data.result
      this.loading = false
      // this.checkUser(data.result.contextId)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //关闭PDF预览弹窗
    async PDFClose() {
      this.PDFshow = false
      this.loading = false
      // let { data } = await this.$Ajax.post(
      //   '/api/services/app/OtherApplicationApi/GenerateResetPasswordPdf?guid=' + guid
      // )
      this.pdfCode = null
      // this.checkUser(data.result.contextId)
    },

    // 打开核验经办人弹窗获取二维码
    async checkUserOpen(guid) {
      this.QRshow = true
      this.loading = true
      this.key = guid + '|' + new Date().getTime()
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetSignQRByResetPassword?key=' + this.key
      )
      this.QRcode = data.result.qrBase64String
      this.loading = false
      this.checkUser(data.result.contextId)
    },
    // 核验经办人 获取个人信息轮询
    checkUser(contextId) {
      let _this = this
      const poll = async () => {
        let { data } = await this.$Ajax.get(
          `/api/services/app/OtherApplicationApi/CheckSignResult`,
          {
            params: { contextId },
          }
        )
        if (data.result.success) {
          // _this.bindUserColse()
          _this.colseQR()
          _this.PDFOpen(contextId)
          // this.$Message.success({
          //   content: '核验成功',
          //   background: true,
          //   duration: 6,
          // })
        } else {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },

    async submitPassword() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认提交申请？</p>',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          this.loading = true
          try {
            let data = await this.$Ajax.post(
              '/api/services/app/OtherApplicationApi/SubmitResetPasswordApplication?guid=' +
                this.form.guid
            )

            this.loading = false
            if (data.data.success) {
              this.$Message.success({
                content: '提交成功',
                background: true,
                duration: 6,
              })
            }

            this.$emit('setResult', data.data.result)
            this.next(null, 100)
          } catch (error) {
            this.loading = false
          }
        },
        onCancel: () => {},
      })
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      this.$refs['passwordResetForm'].validateField(property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>
<style scoped>
._link {
  text-decoration-line: underline;
  background: transparent;
}
</style>
